import type { Availability } from '@/schemas/API/GET/employee/availability/response';
import type { CreateAvailability } from '@/schemas/API/POST/employee/availability/request';
import dayjs from 'dayjs';
import { dateFormat } from '..';

export function generateAvailabilities(
  availabilitiesToRepeat: Availability[],
  count: number,
  freq: 'dnů' | 'týdnů' | 'ob. týdnů' | 'měsíců'
): CreateAvailability[] {
  if (availabilitiesToRepeat.length === 0) return [];

  const startDate = dayjs(availabilitiesToRepeat[0].date);
  const newAvailabilities: CreateAvailability[] = [];
  const dates: Date[] = [];

  for (let i = 1; i <= count; i++) {
    switch (freq) {
      case 'dnů':
        dates.push(startDate.add(i, 'day').toDate());
        break;

      case 'týdnů':
        dates.push(startDate.add(i, 'week').toDate());
        break;

      case 'ob. týdnů':
        dates.push(startDate.add(i * 2, 'week').toDate());
        break;

      case 'měsíců':
        dates.push(startDate.add(i, 'month').toDate());
        break;
    }
  }

  // console.info(
  //   'Generated new dates:',
  //   dates.map(d => dayjs(d).format(dateFormat))
  // );

  dates.forEach(d => {
    availabilitiesToRepeat.forEach(a => {
      newAvailabilities.push({
        date: dayjs(d).format(dateFormat),
        startTime: a.startTime,
        endTime: a.endTime,
      });
    });
  });

  return newAvailabilities;
}
